import { isTnCaseNumberInputEnabled } from "../features/tn-case-number-input/featureFlag";
import { useFeatureFlags } from "./useFeatureFlags";

export function useTnCaseNumberInputEnabled(): boolean {
  const featureFlags = useFeatureFlags();
  return isTnCaseNumberInputEnabled(featureFlags);
}
